/* src/app/webhook-creator/webhook-creator/webhook-form-components/webhook-form-textbox/webhook-form-textbox.component.scss */
.ant-input-clear-icon {
  margin-right: 6px;
  cursor: pointer;
}
.action-button-container {
  padding-left: 10px;
}
:host ::ng-deep .ant-modal-body {
  height: 70vh;
  padding: 0;
}
/*# sourceMappingURL=webhook-form-textbox.component.css.map */
